import ApiClient from './ApiClient';

class GoogleBusinessReviewsAPI extends ApiClient {
  constructor() {
    super('google_business_reviews', { accountScoped: true });
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }
}

export default new GoogleBusinessReviewsAPI();
